import { useMemo } from "react";
import { createListCollection } from "@ark-ui/react";

import { useTranslation } from "@/lib/i18n";
import { usePublishedLocationsQuery } from "@/features/dashboard/features/dashboard";
import {
  useDashboardStoreActions,
  useSelectedLocationId,
} from "@/features/dashboard/store";
import Select from "@/components/select/select";

interface LocationSelectorProps {
  dashboardId: string;
}

export default function LocationSelector({ dashboardId }: LocationSelectorProps) {
  const { t } = useTranslation();
  const locationsQuery = usePublishedLocationsQuery(dashboardId);
  const { setSelectedLocationId } = useDashboardStoreActions();
  const selectedLocationId = useSelectedLocationId();

  const locationOptions = useMemo(() => {
    return (
      locationsQuery.data?.map((location) => ({
        label: location.name,
        value: location.id,
      })) || []
    );
  }, [locationsQuery.data]);

  if (!locationsQuery.data?.length) {
    return null;
  }

  const locationCollection = createListCollection({
    items: locationOptions,
  });

  return (
    <Select
      label={t("common.location")}
      collection={locationCollection}
      value={selectedLocationId}
      onValueChange={setSelectedLocationId}
      placeholder={t("common.location")}
    />
  );
}
